var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVillaAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4429 18.2607L15.4705 21.2606L15.5638 7.11328L23.513 7.15997L23.4429 18.2607Z",
    fill: "#291482"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4103 66.9821L10.6145 66.6553L10.8946 25.5906L35.2673 6.96094L60.6905 25.9174L60.4103 66.9821Z",
    fill: "#ACA2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3455 53.7207L35.4386 39.8418L53.7181 39.9645L53.6249 53.8433L35.3455 53.7207Z",
    fill: "#C6E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.6285 53.8393L53.7219 39.9605L35.4424 39.8438L53.6285 53.8393Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.384 3.54102L10.9063 23.8165L10.8596 30.6101L35.3257 10.8481L60.6555 30.9369L60.6905 25.0772L35.384 3.54102Z",
    fill: "#9CA6C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9444 2L5 26.4427L10.0543 29.9678L35.8977 9.55225L61.4726 30.3064L66.562 26.8629L35.9444 2Z",
    fill: "#7A6DEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10742 66.6289L8.12484 64.0376L63.2084 64.4079L63.191 66.9993L8.10742 66.6289Z",
    fill: "#EABC6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6155 64.1172L15.738 45.9661L28.6947 46.0536L28.5722 64.2046L15.6155 64.1172Z",
    fill: "#291482"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.5167 47.5586H26.8864L20.8633 53.4883L21.7271 53.5L27.5167 47.792V47.5586Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8691 53.4609L16.9092 47.4845L27.5197 47.5556L27.4796 53.5321L16.8691 53.4609Z",
    fill: "#C6E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.5167 53.2547L21.7271 47.5584L27.4817 47.5117L27.5167 53.2547Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.7114 53.5349L16.8828 49.7529L16.8711 49.0059L21.4585 53.5349H20.7114Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.6714 29.2676L29.6791 28.112L40.7565 28.186L40.7488 29.3416L29.6714 29.2676Z",
    fill: "#9CA6C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0181 28.3106L40.0648 21.7272C40.0881 19.0775 37.9403 16.9181 35.3023 16.8947C32.6526 16.8714 30.4931 19.0192 30.4698 21.6572L30.4231 28.2406L40.0181 28.3106Z",
    fill: "#BEBDC4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6096 28.3101L39.6563 21.7267C39.6679 19.2988 37.7186 17.3144 35.2907 17.2911C32.8627 17.2794 30.8784 19.2287 30.855 21.6567L30.8083 28.2401L39.6096 28.3101Z",
    fill: "#C6E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6753 28.793L29.683 27.6374L40.7604 27.7115L40.7527 28.8671L29.6753 28.793Z",
    fill: "#616FB3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.6563 24.2594L33.2246 17.7344L33.7966 17.746L39.6563 23.6758V24.2594Z",
    fill: "#8CC1EA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.104 17.3025V17.3843L35.034 17.3142C35.0573 17.3025 35.0807 17.3025 35.104 17.3025Z",
    fill: "#8CC1EA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0217 33.6387L10.0286 32.6231L61.4586 32.9687L61.4518 33.9842L10.0217 33.6387Z",
    fill: "#616FB3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6079 66.6777L15.6247 64.1097L28.5814 64.1943L28.5646 66.7623L15.6079 66.6777Z",
    fill: "#5C95BE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4868 7.70508L13.5084 4.50675L25.5896 4.58819L25.5681 7.78651L13.4868 7.70508Z",
    fill: "#7A6DEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillaAddressIcon);
export default __webpack_public_path__ + "static/media/villa-address-icon.9170a9a2c2c4a4258eeac23a4b63bc70.svg";
export { ForwardRef as ReactComponent };